export default "__VITE_ASSET__CqUxPxLt__"